import React from 'react';

function highlight(index) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 110 94">
      <path
        stroke={`url(#${index}-paintlinear)`}
        strokeWidth="4"
        d="M108 47a52.998 52.998 0 01-78.533 46.444 53 53 0 01-2.866-91.193"
      ></path>
      <defs>
        <linearGradient
          id={`${index}-paintlinear`}
          x1="55"
          x2="55"
          y1="-8"
          y2="102"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.49" stopColor="#fff" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default highlight;
